import { takeUntil, finalize, map, first, switchMap } from "rxjs/operators";
import { Component, Inject, OnInit } from "@angular/core";
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { GroupsService } from "src/app/groups/groups.service";
import { AuthService, AuthType } from "src/app/shared/services/auth.service";
import { of, Subject } from "rxjs";
import { LoadingService } from "src/app/shared/components/loading/loading.service";
import { GroupDetail } from "src/app/groups/models/group-detail.model";
import { SubSink } from "subsink";
import { Addon } from "src/app/shared/models/addon.model";
import { Location } from "@angular/common";

const STEMEXE2 = 'stemexe2.0';
const STEMEXE = 'stemexe';

@Component({
  selector: "xcdrs-signin-propose",
  templateUrl: "./signin-propose.component.html",
  styleUrls: ["./signin-propose.component.scss"],
})
export class SigninProposeComponent implements OnInit {
  groupDetails: GroupDetail;
  appearanceLogoUrl: string;
  private subs: SubSink = new SubSink();
  private destroy$: Subject<void> = new Subject<void>();
  userSubGroups: string[] = [];
  sourceParam: string = STEMEXE;

  constructor(
    private dialogRef: MatDialogRef<SigninProposeComponent>,
    private groupsService: GroupsService,
    private authService: AuthService,
    private loadingService: LoadingService,
    private location: Location,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const {queryParams} = data;
    if (queryParams) {
      if (queryParams['source']) {
        this.sourceParam = queryParams['source'];
      }
    }
  }

  ngOnInit(): void {
    this.groupsService
      .getGroupDetails(this.authService.idenediGroupId)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.loadingService.loadingOff())
      )
      .subscribe((group) => (this.groupDetails = group));

    this.fetchAddons();
  }

  isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  fetchAddons() {
    this.subs.sink = this.authService
      .getAddonsAuth(this.authService.idenediGroupId)
      .pipe(
        first(),
        switchMap((addons) => {
          if (this.isLoggedIn()) {
            return this.groupsService
              .fetchUserSubGroups(this.authService.idenediGroupId)
              .pipe(
                map((subgroups) => {
                  this.userSubGroups = subgroups;
                  return addons;
                })
              );
          }
          return of(addons);
        })
      )
      .subscribe((addons: Addon[]) => {
        const appApprearanceAddon = addons.find(
          (addon) => addon.Type === AuthType.AppAppearance
        );
        this.appearanceLogoUrl = appApprearanceAddon?.PublicProperties?.logoUrl;
      });
  }

  proceed(path: string): void {
    this.dialogRef.close(path);
  }

  skip(): void {
    this.dialogRef.close(false);
    if(this.sourceParam === STEMEXE2) {
      this.goBack();
    }
  }

  goBack(): void {
    this.location.back();
  }
}
